import { Box, Button, Divider, Input, ModalBody, ModalCloseButton, ModalFooter, ModalHeader, Text } from "@chakra-ui/react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const ManagementMailModal = ({ setMailModalOpen, mailFormRef, selectedEmployees, openUniqueMemberPreview }: any) => {
    return (
        <Box>
            <ModalHeader className="font-poppins text_2xl text_medium" textAlign="center">Send Mail</ModalHeader>
            <Divider />
            <ModalCloseButton />

            <ModalBody>
                <Box mb={6} p={5} borderWidth="1px" borderColor="gray.200" borderRadius="xl" bg="white" boxShadow="0 2px 8px rgba(0, 0, 0, 0.08)">
                    <Box mb={4}>
                        <Text className='font-poppins text_md text_medium' mb={2}>Subject <Text as="span" color="red.500" ml={1}>*</Text></Text>
                        <Input placeholder="Subject"
                            onChange={(e) => {
                                mailFormRef.current.subject = e.target.value;
                            }}
                        />
                    </Box>

                    <Box mb={4}>
                        <Text className='font-poppins text_md text_medium' mb={2}>Mail Body <Text as="span" color="red.500" ml={1}>*</Text></Text>
                        <SunEditor
                            height="250px"
                            onChange={(content) => {
                                mailFormRef.current.message = content;
                            }}
                        />
                    </Box>
                </Box>
            </ModalBody>

            <ModalFooter gap={2}>
                <Button colorScheme="gray" onClick={() => setMailModalOpen(false)}>
                    Cancel
                </Button>

                <Button colorScheme="green" isDisabled={selectedEmployees.length === 0} onClick={openUniqueMemberPreview}>
                    View Unique Members of {selectedEmployees.length} employees AND Send Mail
                </Button>
            </ModalFooter>
        </Box>
    )
}

export default ManagementMailModal